export default {
	office_address: {
		title: '所在地',
		address: '〒100-0000 韓国ソウル特別市中区南大門路39',
	},
	connect: {
		title: 'お問い合わせ',
		phone: {
			label: '+82 2-852-2548',
			alt: '電話アイコン',
		},
		whatsapp: {
			label: '+82 2-852-2548',
			alt: 'WhatsAppアイコン',
		},
		email: {
			support: 'support[at]jpworldpay.com',
			info: 'info[at]jpworldpay.com',
			alt: 'メールアイコン',
		},
	},
	navigation: {
		individual: {
			title: '個人のお客様',
			menu_items: {
				online_shopping: 'オンラインショッピング',
				offline_kiosk: '店頭キオスク',
				pay_with_qr: 'QRコード決済',
				transaction_cashback: '取引とキャッシュバック',
				send_asset: '資産送金',
				asset_request: '資産リクエスト',
				get_deposit: '入金',
				fee: '手数料',
				wallet: 'ウォレット',
				account: 'アカウント',
				sell: '売却',
				exchanging_currency: '通貨両替',
			},
		},
		business: {
			title: '法人のお客様',
			menu_items: {
				getting_started: 'はじめに',
				accepting_payment: '決済受付',
				make_payment: '支払い',
				risk_management: 'リスク管理',
				about_company: '会社概要',
				platforms_features: 'プラットフォームと機能',
				payment_method: '決済方法',
				global_payment: 'グローバル',
				global_processing: 'グローバル決済処理',
			},
		},
		other_links: {
			title: 'その他のリンク',
			menu_items: {
				about: 'OneTeherについて',
				get_deposit: '入金',
				development: '開発',
				customer_service: 'カスタマーサービス',
				testimonial: 'お客様の声',
				contact: 'お問い合わせ',
			},
		},
		terms_policy: {
			title: '規約とポリシー',
			menu_items: {
				privacy: 'プライバシーポリシー',
				cookies: 'クッキーポリシー',
				terms: '利用規約',
			},
		},
	},
	social_media: {
		title: 'フォローする',
		platforms: {
			facebook: {
				label: 'Facebook',
				alt: 'Facebookアイコン',
			},
			twitter: {
				label: 'Twitter',
				alt: 'Twitterアイコン',
			},
			linkedin: {
				label: 'LinkedIn',
				alt: 'LinkedInアイコン',
			},
			youtube: {
				label: 'YouTube',
				alt: 'YouTubeアイコン',
			},
		},
	},
	copyright: {
		text: 'ⓒ JP WORLD Pay. 無断複写・転載を禁じます。.',
	},
	accessibility: {
		logo_alt: 'JPWorldPayフッターロゴ',
	},

	footermob: {
		main_head: '私たちとつながりましょう',
		mail1: 'support[at]jpworldpay.com',
		mail2: 'info[at]jpworldpay.com',
		individual: {
			title: '個人',
			list1: 'オンラインショッピング',
			list2: 'オフラインキオスク',
			list3: 'QRコードで支払う',
			list4: '取引とキャッシュバック',
			list5: 'アセットの送信',
			list6: 'アセットリクエスト',
			list7: 'デポジットを受け取る',
			list8: '手数料',
			list9: 'ウォレットを入手する',
			list10: 'アカウント',
			list11: '売る',
			list12: '通貨の両替',
		},
		business: {
			title: '仕事',
			list1: 'はじめる',
			list2: '支払いの受け入れ',
			list3: '支払いをする',
			list4: 'リスク管理',
			list5: '会社について',
			list6: 'プラットフォームと機能',
			list7: '支払方法',
			list8: 'グローバルな支払い処理',
		},
		OtherLinks: {
			title: 'その他のリンク',
			list1: 'JPWorldPay について',
			list2: 'デポジットを受け取る',
			list3: '発達',
			list4: '顧客サービス',
			list5: 'お客様の声',
			list6: 'お問い合わせ',
		},
		terms: {
			title: '利用規約とポリシー',
			list1: 'プライバシーポリシ',
			list2: 'クッキーポリシー',
			list3: '利用規約',
		},
	},
};
